<script setup lang="ts">
import { ChevronDown, X } from 'lucide-vue-next'
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import Filter from '~~/src/components/Icon/Filter/index.vue'
import { Switch } from '@/components/ui/switch'

const props = defineProps<{
  separatedByType: boolean
  justIcon?: boolean
}>()

// emit
const emit = defineEmits<{
  (e: 'update:filterByMe', value: boolean): void
  (e: 'update:separatedByType', value: boolean): void
}>()

const isSavedMode = ref(false)
const isFilterByMe = ref(false)
const separatedByType = ref(props.separatedByType)
const currentFilterLabel = computed(() => {
  if (isFilterByMe.value)
    return 'Created by Me'

  if (separatedByType.value)
    return 'All Items'

  if (isSavedMode.value)
    return 'Saved Items'

  if (isSavedMode.value && isFilterByMe.value)
    return '2 Filters'

  return 'All Items'
})

const filterByMe = () => {
  isFilterByMe.value = !isFilterByMe.value
  emit('update:filterByMe', isFilterByMe.value)
}

const toggleSeparatedByType = () => {
  emit('update:separatedByType', separatedByType.value)
}
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <div>
        <Button
          v-if="!justIcon" variant="outline" class="ml-auto group relative hidden sm:flex"
        >
          <span>{{ currentFilterLabel }}</span>
          <ChevronDown class="ml-2 h-4 w-4" />
          <div v-if="isFilterByMe" class="absolute right-[17px] top-[11px] w-4 h-4 bg-gray3 rounded-full flex items-center justify-center cursor-pointer transition-opacity opacity-0 group-hover:opacity-100">
            <X
              class="w-1.5 h-1.5 text-gray-100"
              @click.stop="filterByMe"
            />
          </div>
        </Button>
        <Button
          v-if="justIcon"
          variant="snack-ghost"
          size="icon"
          class="ml-auto group relative flex rounded-full shrink-0"
          :class="{
            'sm:hidden': !justIcon,
          }"
        >
          <Filter class="h-4 w-4" />
        </Button>
      </div>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuCheckboxItem
        :key="1"
        class="capitalize"
        :checked="isFilterByMe"
        @update:checked="filterByMe"
      >
        Created by Me
      </DropdownMenuCheckboxItem>

      <DropdownMenuSeparator />
      <div class="flex gap-2 items-center">
        <span class="text-sm text-gray-500">
          Separate by type
        </span>
        <Switch v-model:checked="separatedByType" @update:checked="toggleSeparatedByType" />
      </div>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
